import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import api, { errMsg } from "@/lib/api";

export default function ResetPassword() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset successful");
      navigate("/admin/login");
    } catch (err) {
      toast.error(errMsg(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center px-6">
      <div className="vl-noise" />
      <form onSubmit={submit} className="relative z-10 w-full max-w-md vl-card rounded-2xl p-8" data-testid="reset-form">
        <h1 className="font-serif-display text-2xl text-[var(--vl-ivory)] mb-6">{t("password")}</h1>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} placeholder={t("password")} className="vl-input rounded-lg px-4 py-3 w-full" data-testid="reset-password-input" />
        <button type="submit" disabled={loading || !token} className="vl-btn-gold rounded-full px-7 py-3 text-sm tracking-widest uppercase font-medium flex items-center gap-2 w-full justify-center mt-6" data-testid="reset-submit-btn">
          {loading && <Loader2 size={16} className="animate-spin" />} {t("save")}
        </button>
        <Link to="/admin/login" className="block text-center mt-5 text-xs text-[var(--vl-stone)] hover:text-[var(--vl-gold)]">{t("back")}</Link>
      </form>
    </div>
  );
}
